import cx from 'classnames'

import Styles from './EnableAutoReload.module.scss'

import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Check02 } from 'blaze-ui/icons/16'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

export const EnableAutoReload = ({
  shouldAutoReloadCredits,
  toggleAutoReloadCredits,
  name,
  className,
  variant = 'multi-line',
}: {
  shouldAutoReloadCredits: boolean
  toggleAutoReloadCredits: () => void
  name: string
  className?: string
  variant?: 'multi-line' | 'single-line'
}) => {
  if (variant === 'single-line') {
    return (
      <div className={cx(Styles.autoReloadCreditsContainer, Styles.noBackground, className)}>
        <div className={Styles.textAndToggle}>
          <div className={Styles.text}>
            <Heading level={5}>Auto-reload credits</Heading>
            <Text variant="secondary" color="var(--dark-60)">
              Refill 100 credits at a time, max $50/mo
            </Text>
          </div>
          <ToggleButton checked={shouldAutoReloadCredits} name={name} handleChange={toggleAutoReloadCredits} />
        </div>
      </div>
    )
  }

  return (
    <div className={cx(Styles.autoReloadCreditsContainer, className)}>
      <div className={Styles.textAndToggle}>
        <Heading level={5}>Enable credits auto-reload</Heading>
        <ToggleButton checked={shouldAutoReloadCredits} name={name} handleChange={toggleAutoReloadCredits} />
      </div>
      <div className={Styles.checklist}>
        <div className={Styles.checklistItem}>
          <Check02 color="var(--dark-40)" />
          <Text variant="secondary" color="var(--dark-60)">
            Keep content generating without interruption
          </Text>
        </div>
        <div className={Styles.checklistItem}>
          <Check02 color="var(--dark-40)" />
          <Text variant="secondary" color="var(--dark-60)">
            Automatically add 100 credits when running low, up to $50/month
          </Text>
        </div>
        <div className={Styles.checklistItem}>
          <Check02 color="var(--dark-40)" />
          <Text variant="secondary" color="var(--dark-60)">
            Change anytime
          </Text>
        </div>
      </div>
    </div>
  )
}
